import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

import { PropsType } from '@contexts/Auth/Auth.types'
import { ROUTES } from '@routes'

import { clearPostLoginRedirect, getPostLoginRedirect } from './postLoginRedirect'

export const startNavigation = (props: PropsType) => {
  const currentPathName = window.location.pathname

  // If the user originally tried to open a deep link, prefer that — it was saved
  // before redirecting them to /login and survives any external OAuth redirect.
  const storedUrl = getPostLoginRedirect()
  if (storedUrl) {
    clearPostLoginRedirect()
    props.history.push(storedUrl)
    return
  }

  const nextLocation = get(props, 'location.state.nextLocation', {
    pathname: currentPathName,
  })

  const disabledPathsWhenLogged = [ROUTES.login.path, ROUTES.home.path]

  const shouldGoToDashboard = disabledPathsWhenLogged.includes(nextLocation.pathname)
  const shouldForcePush = disabledPathsWhenLogged.includes(currentPathName)

  if (!isEqual(nextLocation.pathname, currentPathName) || shouldForcePush) {
    props.history.push(shouldGoToDashboard ? ROUTES.dashboard.path : nextLocation)
  }
}
